/**
 * Maps Google Places primary types (Table A) to Tycho business category/type keys.
 * Ported from ploutos `shared/googlePlaces.ts` (`googlePlaceTypeToBusinessCategoryType`).
 *
 * @see https://developers.google.com/maps/documentation/places/web-service/place-types#table-a
 */
import type { BusinessCategoryType } from "@/web/lib/schemaUtils/businessCategories";

export const GOOGLE_PLACE_TYPE_TO_BUSINESS_TYPE: Record<string, BusinessCategoryType> = {
  asian_grocery_store: "groceryAndConvenience.specialtyMarket",
  auto_parts_store: "automotive.autoPartsStore",
  bicycle_store: "retail.bicycleShop",
  book_store: "retail.bookstore",
  butcher_shop: "groceryAndConvenience.specialtyMarket",
  cell_phone_store: "retail.electronicsStore",
  clothing_store: "retail.clothingStore",
  convenience_store: "groceryAndConvenience.convenienceStore",
  department_store: "retail.clothingStore",
  discount_store: "retail.store",
  electronics_store: "retail.electronicsStore",
  food_store: "groceryAndConvenience.groceryStore",
  furniture_store: "retail.furnitureStore",
  gift_shop: "retail.giftShop",
  grocery_store: "groceryAndConvenience.groceryStore",
  hardware_store: "retail.hardwareStore",
  home_goods_store: "retail.homeGoodsStore",
  home_improvement_store: "retail.hardwareStore",
  jewelry_store: "retail.jewelryStore",
  liquor_store: "groceryAndConvenience.liquorStore",
  market: "groceryAndConvenience.groceryStore",
  pet_store: "petCare.petStore",
  shoe_store: "retail.shoeStore",
  shopping_mall: "retail.shoppingMall",
  sporting_goods_store: "retail.sportingGoodsStore",
  store: "retail.store",
  supermarket: "groceryAndConvenience.groceryStore",
  wholesaler: "professionalServices.wholesaler",
  car_dealer: "automotive.carDealer",
  car_repair: "automotive.carRepair",
  car_wash: "automotive.carWash",
  car_rental: "automotive.carRental",
  gas_station: "automotive.gasStation",
  rest_stop: "automotive.gasStation",
  farm: "agriculture.farm",
  ranch: "agriculture.farm",
  art_gallery: "artAndCulture.artGallery",
  art_studio: "artAndCulture.artStudio",
  museum: "artAndCulture.museum",
  auditorium: "artAndCulture.auditorium",
  performing_arts_center: "artAndCulture.performingArtsCenter",
  amusement_center: "entertainment.amusementCenter",
  amusement_park: "entertainment.amusementPark",
  bowling_alley: "entertainment.bowlingAlley",
  casino: "entertainment.casino",
  concert_hall: "entertainment.concertHall",
  movie_theater: "entertainment.movieTheater",
  night_club: "entertainment.nightclub",
  acai_shop: "foodAndBeverage.juiceBar",
  afghani_restaurant: "foodAndBeverage.restaurant",
  african_restaurant: "foodAndBeverage.restaurant",
  american_restaurant: "foodAndBeverage.restaurant",
  asian_restaurant: "foodAndBeverage.restaurant",
  bagel_shop: "foodAndBeverage.bakery",
  bakery: "foodAndBeverage.bakery",
  bar: "foodAndBeverage.bar",
  bar_and_grill: "foodAndBeverage.restaurant",
  barbecue_restaurant: "foodAndBeverage.restaurant",
  brazilian_restaurant: "foodAndBeverage.restaurant",
  breakfast_restaurant: "foodAndBeverage.breakfastRestaurant",
  brunch_restaurant: "foodAndBeverage.breakfastRestaurant",
  buffet_restaurant: "foodAndBeverage.restaurant",
  cafe: "foodAndBeverage.coffeeShop",
  cafeteria: "foodAndBeverage.restaurant",
  candy_store: "retail.giftShop",
  cat_cafe: "foodAndBeverage.coffeeShop",
  chinese_restaurant: "foodAndBeverage.restaurant",
  chocolate_factory: "foodAndBeverage.bakery",
  chocolate_shop: "foodAndBeverage.bakery",
  coffee_shop: "foodAndBeverage.coffeeShop",
  confectionery: "foodAndBeverage.bakery",
  deli: "foodAndBeverage.deli",
  dessert_restaurant: "foodAndBeverage.bakery",
  dessert_shop: "foodAndBeverage.bakery",
  diner: "foodAndBeverage.restaurant",
  dog_cafe: "foodAndBeverage.coffeeShop",
  donut_shop: "foodAndBeverage.bakery",
  fine_dining_restaurant: "foodAndBeverage.restaurant",
  food_court: "foodAndBeverage.restaurant",
  french_restaurant: "foodAndBeverage.restaurant",
  greek_restaurant: "foodAndBeverage.restaurant",
  hamburger_restaurant: "foodAndBeverage.restaurant",
  ice_cream_shop: "foodAndBeverage.iceCreamShop",
  indian_restaurant: "foodAndBeverage.restaurant",
  indonesian_restaurant: "foodAndBeverage.restaurant",
  italian_restaurant: "foodAndBeverage.restaurant",
  japanese_restaurant: "foodAndBeverage.restaurant",
  juice_shop: "foodAndBeverage.juiceBar",
  korean_restaurant: "foodAndBeverage.restaurant",
  lebanese_restaurant: "foodAndBeverage.restaurant",
  meal_delivery: "foodAndBeverage.restaurant",
  meal_takeaway: "foodAndBeverage.restaurant",
  mediterranean_restaurant: "foodAndBeverage.restaurant",
  mexican_restaurant: "foodAndBeverage.restaurant",
  middle_eastern_restaurant: "foodAndBeverage.restaurant",
  pizza_restaurant: "foodAndBeverage.restaurant",
  pub: "foodAndBeverage.bar",
  ramen_restaurant: "foodAndBeverage.restaurant",
  restaurant: "foodAndBeverage.restaurant",
  sandwich_shop: "foodAndBeverage.sandwichShop",
  seafood_restaurant: "foodAndBeverage.restaurant",
  spanish_restaurant: "foodAndBeverage.restaurant",
  steak_house: "foodAndBeverage.restaurant",
  sushi_restaurant: "foodAndBeverage.restaurant",
  tea_house: "foodAndBeverage.coffeeShop",
  thai_restaurant: "foodAndBeverage.restaurant",
  turkish_restaurant: "foodAndBeverage.restaurant",
  vegan_restaurant: "foodAndBeverage.restaurant",
  vegetarian_restaurant: "foodAndBeverage.vegetarianRestaurant",
  vietnamese_restaurant: "foodAndBeverage.restaurant",
  wine_bar: "foodAndBeverage.bar",
};
